import React from "react";
import "../css/Testimonials.css";

const testimonialsData = [
  {
    name: "Alice Johnson",
    role: "CEO, TechCorp",
    feedback:
      "Inquizene delivered a robust internal platform with exceptional attention to architecture, security, and scalability. Their engineering discipline is evident in every detail."
  },
  {
    name: "Mark Thompson",
    role: "Product Manager, InnovateX",
    feedback:
      "The team approached our requirements with clarity and structure. The resulting system is clean, predictable, and built to grow alongside our business."
  },
  {
    name: "Sophia Lee",
    role: "Founder, BrightSolutions",
    feedback:
      "Working with Inquizene felt seamless. Communication was transparent, timelines were respected, and the final delivery exceeded expectations."
  }
];

export default function Testimonials() {
  return (
    <section className="testimonials">
      <div className="testimonials-bg" />

      <div className="testimonials-wrapper">
        <span className="testimonials-label">
          Trusted Partnerships
        </span>

        <h2 className="testimonials-title">
          What Our <span>Clients Say</span>
        </h2>

        <p className="testimonials-lead">
          We work closely with founders, product teams, and organizations
          to deliver software that is dependable, scalable, and thoughtfully engineered.
        </p>

        <div className="testimonials-grid">
          {testimonialsData.map((item, index) => (
            <div className="testimonial-card" key={index}>
              <p className="testimonial-feedback">
                “{item.feedback}”
              </p>

              <div className="testimonial-author">
                <span className="author-name">{item.name}</span>
                <span className="author-role">{item.role}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
